import { featureItems } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 text-center mb-8">
          平台特色
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {featureItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg border border-background-200/70 p-6 text-center hover:border-primary-200 transition-colors duration-200"
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full mx-auto mb-4 ${
                i === 0 ? 'bg-primary-100' : i === 1 ? 'bg-accent-100' : 'bg-secondary-100'
              }`}>
                <i className={`${item.icon} text-2xl md:text-3xl ${
                  i === 0 ? 'text-primary-600' : i === 1 ? 'text-accent-600' : 'text-secondary-600'
                }`}></i>
              </div>
              <h3 className="text-base font-heading text-foreground-900 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}